import type { DirectionType } from '@/app/types/log'

import { MESSAGE_INBOUND } from './definitions'

type DirectionFields = {
  direction: DirectionType
}

type MessageNumberFields = DirectionFields & {
  recipient: string
  sender: string
}

type CallNumberFields = DirectionFields & {
  callerId: string
  to: string
}

export const isInbound = (item: DirectionFields) => item.direction === MESSAGE_INBOUND

export const getContactNumber = (item: MessageNumberFields) => (isInbound(item) ? item.sender : item.recipient)

export const getSenderReceiverNumber = (item: MessageNumberFields) => (isInbound(item) ? item.recipient : item.sender)

export const getCallerNumber = (item: CallNumberFields) => (isInbound(item) ? item.callerId : item.to)

export const getCallerReceiverNumber = (item: CallNumberFields) => (isInbound(item) ? item.to : item.callerId)
